import React from 'react';
import { Button, SelectInput, Text } from '@ui';
import { translatorFor } from '../shared/i18n';
import { humanize, humanizedSelectOptions } from '../shared/types';
import { NO_SUBTYPE } from './mappingDraft';
const t = translatorFor('equipment_mapping');
export function buildMappingColumns({ catalogOptions, deviceTypeOptions, deviceSubtypeOptions, disabled, onChange, onRemove }) {
    function InspectPointCell({ item }) {
        var _a;
        if (!item.isNew) {
            return (React.createElement(Text, { variant: "body", as: "span" },
                humanize(item.ipType),
                item.ipSubtype !== NO_SUBTYPE && ` / ${humanize(item.ipSubtype)}`));
        }
        const subtypes = (_a = deviceSubtypeOptions[item.ipType]) !== null && _a !== void 0 ? _a : [];
        return (React.createElement(React.Fragment, null,
            React.createElement(SelectInput, { id: `service-titan-map-type-${item.key}`, options: humanizedSelectOptions(deviceTypeOptions), value: item.ipType || undefined, disabled: disabled, showSearch: true, onChange: (value) => onChange(item.key, { ipType: String(value), ipSubtype: NO_SUBTYPE }) }),
            subtypes.length > 0 && (React.createElement(SelectInput, { id: `service-titan-map-subtype-${item.key}`, options: [{ value: NO_SUBTYPE, label: t('no_subtype') }, ...humanizedSelectOptions(subtypes)], value: item.ipSubtype, disabled: disabled, showSearch: true, onChange: (value) => onChange(item.key, { ipSubtype: String(value) }) }))));
    }
    function ServiceTitanCell({ item }) {
        const options = catalogOptions.some((option) => option.value === item.stId)
            ? catalogOptions
            : [...(item.stId ? [{ value: item.stId, label: item.stName }] : []), ...catalogOptions];
        return (React.createElement(SelectInput, { id: `service-titan-map-st-${item.key}`, options: options, value: item.stId || undefined, disabled: disabled, showSearch: true, onChange: (value) => {
                var _a, _b;
                const id = String(value);
                onChange(item.key, { stId: id, stName: (_b = (_a = options.find((option) => option.value === id)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '' });
            } }));
    }
    function RemoveCell({ item }) {
        return (React.createElement(Button, { variant: "highlighted", disabled: disabled, "aria-label": t('remove_row', { name: humanize(item.ipType) || t('new_mapping') }), onClick: () => onRemove(item.key) },
            React.createElement("i", { className: "fa-light fa-trash", "aria-hidden": "true" })));
    }
    return [
        { dataKey: 'ipType', label: t('ip_type_heading'), width: '22rem', renderer: InspectPointCell },
        { dataKey: 'stId', label: t('st_type_heading'), width: '26rem', renderer: ServiceTitanCell },
        { dataKey: 'remove', label: '', width: '6rem', renderer: RemoveCell }
    ];
}
